import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import EpisodeReaction from '../../../domain/entities/EpisodeReaction';

export default function reducer(
  state: {[key: number]: EpisodeReaction} = {},
  action: AnyAction,
): {[key: number]: EpisodeReaction} {
  switch (action.type) {
    case Types.IndexEpisodeReactionsSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: EpisodeReaction}, record: EpisodeReaction) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowEpisodeReactionSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    default:
      return state;
  }
}
